import { getRequired } from "./apiClient";

export function getPayload(path: string): Promise<unknown> {
  return getRequired(`/payload?path=${encodeURIComponent(path)}`);
}
